import { GetUsersWithRolesRequestDTO } from '../dtos';

// Query keys for React Query caching and invalidation
export const userManagementQueryKeys = {
  // All user management queries
  all: ['userManagement'] as const,

  // Users with roles queries
  usersWithRoles: (params?: GetUsersWithRolesRequestDTO) =>
    ['userManagement', 'usersWithRoles', params] as const,

  // Single user with role query
  userWithRole: (userId: string, tenantId?: string) =>
    ['userManagement', 'userWithRole', userId, tenantId] as const,

  // User existence check
  userExists: (email: string) => ['userManagement', 'userExists', email] as const,

  // Basic users queries (without roles)
  users: (tenantId?: string) => ['userManagement', 'users', tenantId] as const,

  // Single user query (without roles)
  user: (userId: string) => ['userManagement', 'user', userId] as const,

  // Role-specific queries for easier invalidation
  byRole: (role: string) => ['userManagement', 'byRole', role] as const,

  // Tenant-specific queries for easier invalidation
  byTenant: (tenantId: string) => ['userManagement', 'byTenant', tenantId] as const,

  // Domain-specific queries for easier invalidation
  byDomain: (domainId: string) => ['userManagement', 'byDomain', domainId] as const,

  // Subject-specific queries for easier invalidation
  bySubject: (subjectId: string) => ['userManagement', 'bySubject', subjectId] as const,
} as const;
